import { VwoService } from './../../../../shared/services/vwo/vwo.service';
import { MatDialog } from '@angular/material/dialog';
import { environment } from './../../../../../environments/environment';
import { UtilService } from './../../../../shared/services/util/util.service';
import { VariablesService } from './../../../../shared/services/variables/variables.service';
import { TickrService } from './../../../../shared/services/tickr/tickr.service';
import { StorageService } from './../../../../shared/services/storage/storage.service';
import { Component, Input, OnInit } from '@angular/core';
import { PortfolioService } from '../../../../shared/services';


@Component({
  selector: 'app-tickr',
  templateUrl: './tickr.component.html',
  styleUrls: ['./tickr.component.scss']
})
export class TickrComponent implements OnInit {

  @Input() skipSipTicker;
  @Input() theme;
  userData;

  currentTickrData: any;
  tickr = {
    slideTickrLeft: false,
    slideTickrRight: true,
    isTickrVisible: false,
    showTickr() {
      this.isTickrVisible = true;
      this.slideTickrLeft = true;
      this.slideTickrRight = false;
    },
    hideTickr() {
      this.slideTickrRight = true;
      this.slideTickrLeft = false;
      setTimeout(() => {
        this.isTickrVisible = false;
      }, 400);
    }
  };
  allTickrData;
  campaignId;
  currencyInfo;
  deviceType;
  currency;
  tickrWillShow: boolean;
  tickrShownCount = 0;
  iplocationObj = null;
  anonymousImg = '/assets/images/anonymous.png';
  // tickrArr = this.tickrService.tickrArr;

  constructor(
    private tickrService: TickrService,
    public storageService: StorageService,
    public variablesService: VariablesService,
    private utilService: UtilService,
    private dialog: MatDialog,
    private portfolioService: PortfolioService,
    public vwo: VwoService
  ) { }

  ngOnInit() {
    this.variablesService.userData.subscribe(res => {
      this.userData = res;
    })
    this.campaignId = this.variablesService?.fundraiser?.id;
    this.deviceType = this.utilService.isMobile ? 'Mobile' : 'Desktop';
    this.iplocationObj = this.storageService.getFromSession('iplocation');
    const userDonatedCurrentSession = this.storageService.getFromSession('showBanner');
    if (!this.tickrService.tickrArr?.includes(this.campaignId) && !userDonatedCurrentSession) {
      this.tickrService.resetTickr();
      this.tickrService.willTickrShowObs.next(true);
      this.tickrWillShow = true;
      this.getTickrData();
    } else {
      this.tickrService.willTickrShowObs.next(false);
      this.tickrWillShow = false;
    }
    this.currency = this.storageService.getFromSession('currency');
  }

  getTickrData() {
    try {
      /** Know whether tickr shown => from session storage */

      /**
       * If Tickr show in current session for current campaign then do nothing
       * User should also not have donated in current session
       */
      if (this.tickrWillShow) {
        /** Else get tickr data */
        const payload = {
          campaignId: this.campaignId,
          limit: this.tickrService.reduceDonorsBy,
          currency: this.storageService.getFromSession('currency') || 'INR'
        };
        this.tickrService.getTickrData(payload).subscribe(
          async (response: any) => {
            if (response.error === false) {
              let tickrData = response.data.data;
              try {
                tickrData = await this.addSipUser(tickrData);
              } catch (error) { }
              if (payload.currency === 'INR') {
                tickrData = this.setLocationData(tickrData);
              }
              this.allTickrData = tickrData.reverse();
              let tickrTimeout;
              let dialogOpened = false;
              this.dialog.afterOpened.subscribe(
                (next) => {
                  dialogOpened = true;
                }
              );
              this.variablesService.fundraiser.raised.beforeTickr = this.variablesService?.fundraiser?.raised?.raised;
              for (let i = 0; i < this.allTickrData.length; i++) {
                if (!this.allTickrData[i]?.sip || !this.skipSipTicker) {
                  if (!this.allTickrData[i]?.sip) {
                    // this.variablesService.fundraiser.raised.raised -= Math.round(this.allTickrData[i].donated_amount_current);
                  }
                  tickrTimeout = setTimeout(() => {
                    if (dialogOpened) {
                      clearTimeout(tickrTimeout);
                      return;
                    }
                    this.currentTickrData = this.allTickrData[i];
                    this.currentTickrData.currencyIcon = this.utilService.getCurrencyIcon(this.currentTickrData.iso_currency);

                    this.tickr.showTickr();
                    if (!this.allTickrData[i]?.sip) {
                      // this.tickrService.tickrIsShown.next(this.currentTickrData);
                      this.tickrService.tickrData.push(this.currentTickrData);
                    }
                    ++this.tickrService.tickrShownCount;

                    setTimeout(() => {
                      this.tickr.hideTickr();
                      if (i === this.allTickrData.length - 1) {
                        this.tickrService.lastTickrShownObs.next(true);
                      }
                    }, this.tickrService[this.deviceType].hideAfter); /** Time mentioned for tickr to hide as per device*/
                  }, this.tickrService[this.deviceType].interval[i]); /** Time mentioned for next tickr to show as per device*/
                } else {
                  for (let j = this.tickrService[this.deviceType]?.interval?.length - 1; j >= 0; j--) {
                    if (j >= i) {
                      this.tickrService[this.deviceType].interval[j] = this.tickrService[this.deviceType].interval[j - 1];
                    }
                  }
                }
              }

              /** Set session storage item for tickr*/
              this.tickrService.addCampaignId(this.campaignId); // Remove this comment
            } else {
              this.allTickrData = [];
              this.tickr.hideTickr();
            }
          }
        );
      }
    } catch (err) {
      console.log(err);
    }
  }

  truncateString = (input: string, length: number) => (input && input.length) > length ? `${input.substring(0, length)}...` : input;

  getInitials = (name: string) => name ? name.match(/\b(\w)/g)?.join('') : '';

  onTickrClick(event: Event, close: string) {
    if (close) {
      this.tickr.isTickrVisible = false;
      event.stopPropagation();
    } else {
      this.tickrService.tickrClickObs.next('clicked');
    }
  }

  addSipUser(tickrData: any[]): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        const payload: any = {};
        this.portfolioService.getTickrData(payload).subscribe((res: any) => {
          if (res.data && res.data[0]) {
            const sipUser = Object.assign(res.data[0], {
              donated_amount: res.data[0].amount,
              donated_amount_current: res.data[0].amount,
              donated_amount_local: res.data[0].amount,
              donoravtar: null,
              is_anonymous: 0,
              iso_currency: res.data[0].currency.toUpperCase(),
              sip: true
            });
            tickrData.splice(2, 0, sipUser).join();
            resolve(tickrData);
          } else {
            reject();
          }
        }, () => reject());
      } catch (error) {
        reject(false);
      }
    });
  }

  setLocationData(tickrData) {
    const donors = Math.ceil((this.variablesService?.fundraiser?.raised?.last24hrtotal * 1) / 100) || 0;
    let donorCount;
    let cityName = '';
    if (donors === 1) {
      donorCount = `1 person`;
    } else if (donors > 1) {
      donorCount = `${donors} people`;
    } else if (donors === 0) {
      return tickrData;
    }
    if (this.iplocationObj?.city_name) {
      cityName = `from ${this.iplocationObj.city_name}`;
    }
    tickrData[3] = {
      name: `In the last 24 hours, ${donorCount} ${cityName} contributed to this fundraiser`,
      byLocation: true,
      donated_amount_current: 0
    };
    return tickrData;
  }

}
